'use client'

import React from 'react'
import { useInView } from 'react-intersection-observer'
import { getMediaUrl } from '@/utilities/getMediaUrl'
import { getAltTag } from '@/utilities/getAltTag'
import { formatDateTime } from '@/utilities/formatDateTime'
import { motion } from 'motion/react'
import ParallaxImage from '@/components/Antonie/Components/ParallaxImage'
import { Angebote } from '@/payload-types'

export function AngebotHeroClient({ angebote }: { angebote: Angebote }) {
  const { image, publishedAt, title, slug } = angebote
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
    },
  }
  return (
    <header className="relative h-[60vh] min-h-[500px] overflow-hidden bg-stone-50">
      {/* Background Image */}
      <div className="absolute right-0 top-0 h-full w-2/3 overflow-hidden">
        <ParallaxImage
          src={getMediaUrl(image)}
          alt={getAltTag(image, title)}
          className="h-full w-full object-cover"
        />
        <div className="bg-linear-to-r absolute inset-0 from-stone-50 from-10% to-transparent" />
      </div>

      {/* Content */}
      <div className="relative h-full">
        <div className="container mx-auto h-full px-4 sm:px-6 lg:px-8">
          <motion.div
            ref={ref}
            variants={containerVariants}
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            className="flex h-full flex-col justify-center md:w-1/2"
          >
            <motion.div variants={itemVariants}>
              <motion.h1 className="mb-6 font-serif text-4xl font-light tracking-wide text-black md:text-5xl">
                <span className="text-antonie-brown">{title}</span>
              </motion.h1>
              {angebote.timeline && (
                <motion.p
                  variants={itemVariants}
                  className="mb-8 text-lg font-light leading-relaxed text-black/90 md:text-xl"
                >
                  {angebote.timeline}
                </motion.p>
              )}
            </motion.div>
          </motion.div>
        </div>
      </div>
    </header>
  )
}

export default AngebotHeroClient
